import { ICandidateTag, IPostBulkCandidateTagsList } from 'app/models/Candidate/Tags';
import { TagsCandidateGridRow } from './TagsManagementBulkTagsPicker';

export const mapPickerSelectionsToCandidateTags = (selections: any[]): ICandidateTag[] =>
  (selections || []).map(tag => ({
    category: tag.category,
    isClassicTag: tag.isClassicTag ?? false,
    label: tag.label ?? tag.name ?? tag.description,
    value: tag.value ?? tag.label ?? tag.name,
    id: tag.id ?? tag.tagTypeId ?? null,
    tagTypeId: tag.tagTypeId ?? tag.id ?? null,
    categoryId: tag.categoryId ?? null,
    isHidden: tag.isHidden ?? false,
    isActive: tag.isActive ?? true,
    fullDescription: tag.fullDescription ?? null,
  }));

export const buildBulkCandidateTagsRequest = ({
  selectedRows,
  selectedTags,
  currentEmployeeId,
  currentEmployeeName,
}: {
  selectedRows: TagsCandidateGridRow[];
  selectedTags: any[];
  currentEmployeeId: number;
  currentEmployeeName: string;
}): IPostBulkCandidateTagsList => {
  const candidateTags = mapPickerSelectionsToCandidateTags(selectedTags);

  return {
    currentEmployeeId,
    currentEmployeeName,
    updateCandidateTagsListCommandItems: selectedRows.map(row => ({
      candidateId: Number(row.candidateId),
      brandId: Number(row.brandId),
      candidateTags,
    })),
  };
};
